import { PobierzSpisaneSrodkiLokalizacjiFiltry } from "./pobierzSpisaneSrodkiLokalizacjiFiltry";

export class PobierzSpisaneSrodkiPomieszczeniaFiltry extends PobierzSpisaneSrodkiLokalizacjiFiltry {
    idPomieszczenia: string;
}